import React from 'react';
import './NewPatientss.css';

const NewPatientss = () => {
  return (
    <div id="newPatients">
    <div className="newPatients">
      <p className="xyza">
        We are accepting new patients 18 years of age and older in Michigan and California.
      </p>
      <p className="xyza">
        Currently, we do not accept any insurance plans and employee assistance programs (EAP) of any kind. We will provide a superbill.
      </p>
      <p className="xyza">
          We do not do Workman's Compensation or disability evaluations. We also do not do emotional support animal (ESA) or service animal letters or certifications.
          <br />
          <br />
          We do FMLA & school/work accommodation evaluations and paperwork only for established patients with a sufficient treatment relationship of at least one year.
      </p>
    </div>
    </div>
  );
}

export default NewPatientss;
